var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDefaultClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 12,
    x: 11.889,
    y: 3.404,
    fill: "#D8D8D8",
    rx: 0.5,
    transform: "rotate(45 11.89 3.404)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 12,
    x: 3.404,
    y: 4.111,
    fill: "#D8D8D8",
    rx: 0.5,
    transform: "rotate(-45 3.404 4.11)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefaultClose);
export default __webpack_public_path__ + "static/media/icon_default_close.3d5295c7c663bca4b5979b300ccf0499.svg";
export { ForwardRef as ReactComponent };